import Reveal from '@/components/feature/Reveal';
import { feedItems } from '@/mocks/home';

export default function FeedSection() {
  return (
    <section id="feed" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="font-label text-xs tracking-[0.28em] text-primary-600">
                NEWSFEED
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                收录快讯
              </h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600">
                目录的每一次调整都会记在这里，按时间倒序排好。想了解最近补了哪些
                <strong className="mx-1 font-semibold text-foreground-900">黑料导航资源</strong>
                ，看这一列就够了。
              </p>
              <div className="mt-6 inline-flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
                <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                  <i className="ri-refresh-line text-sm" />
                </span>
                <span className="font-label text-xs text-foreground-600">
                  每日巡检 · 自动归档
                </span>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300/80 pl-6 md:pl-10">
              {feedItems.map((item, index) => (
                <Reveal key={item.id} delay={index * 60}>
                  <li className="relative pb-9 last:pb-0">
                    <span className="absolute -left-[31px] top-1.5 flex h-3 w-3 items-center justify-center md:-left-[47px]">
                      <span
                        className={`h-3 w-3 rounded-full border-2 border-background-50 ${
                          index === 0 ? 'bg-primary-500' : 'bg-accent-400'
                        }`}
                      />
                    </span>
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span
                        className={`font-label text-xs ${
                          index === 0 ? 'text-primary-700' : 'text-foreground-500'
                        }`}
                      >
                        {item.time}
                      </span>
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">
                        {item.category}
                      </span>
                      <span className="flex items-center gap-1 font-label text-[11px] text-foreground-400">
                        <i className="ri-fire-line text-xs" />
                        {item.heat}
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold leading-7 text-foreground-950 md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-7 text-foreground-600">{item.summary}</p>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}